import * as React from 'react'
import { BiUnlink as BrokenLinkIcon } from '@react-icons/all-files/bi/BiUnlink'
import { FaSpinner as SpinnerIcon } from '@react-icons/all-files/fa/FaSpinner'
import { MdArrowDropDown as ArrowDropDown } from '@react-icons/all-files/md/MdArrowDropDown'
import { MdArrowDropDownCircle as DropDownArrow } from '@react-icons/all-files/md/MdArrowDropDownCircle'
import { MdCancel as CancelIcon } from '@react-icons/all-files/md/MdCancel'
import { MdCheckCircle as CheckCircle } from '@react-icons/all-files/md/MdCheckCircle'
import { MdCreditCard as CreditCard } from '@react-icons/all-files/md/MdCreditCard'
import { MdDelete as TrashIcon } from '@react-icons/all-files/md/MdDelete'
import { MdFormatAlignCenter as FormatAlignCenter } from '@react-icons/all-files/md/MdFormatAlignCenter'
import { MdFormatAlignJustify as FormatAlignJustify } from '@react-icons/all-files/md/MdFormatAlignJustify'
import { MdFormatAlignLeft as FormatAlignLeft } from '@react-icons/all-files/md/MdFormatAlignLeft'
import { MdFormatAlignRight as FormatAlignRight } from '@react-icons/all-files/md/MdFormatAlignRight'
import { MdFormatBold as FormatBold } from '@react-icons/all-files/md/MdFormatBold'
import { MdFormatClear } from '@react-icons/all-files/md/MdFormatClear'
import { MdFormatColorFill } from '@react-icons/all-files/md/MdFormatColorFill'
import { MdFormatColorText } from '@react-icons/all-files/md/MdFormatColorText'
import { MdFormatItalic as FormatItalic } from '@react-icons/all-files/md/MdFormatItalic'
import { MdFormatListBulleted as FormatListBulleted } from '@react-icons/all-files/md/MdFormatListBulleted'
import { MdFormatListNumbered as FormatListNumbered } from '@react-icons/all-files/md/MdFormatListNumbered'
import { MdFormatUnderlined as FormatUnderlined } from '@react-icons/all-files/md/MdFormatUnderlined'
import { MdImage as ImageIcon } from '@react-icons/all-files/md/MdImage'
import { MdImportExport as DragIcon } from '@react-icons/all-files/md/MdImportExport'
import { MdMailOutline as EnvelopeIcon } from '@react-icons/all-files/md/MdMailOutline'
import { MdMoreHoriz as EllipsisIcon } from '@react-icons/all-files/md/MdMoreHoriz'
import { MdPeople as PeopleIcon } from '@react-icons/all-files/md/MdPeople'
import { MdRemove as RemoveIcon } from '@react-icons/all-files/md/MdRemove'
import AddCircleSvg from 'assets/icons/add-circle.svg'
import AddTag from 'assets/icons/add-tag.svg'
import ClockSvg from 'assets/icons/alarm.svg'
import AlbumSvg from 'assets/icons/album.svg'
import ArrowDownSvg from 'assets/icons/arrow-down.svg'
import ArrowLeftBigV2 from 'assets/icons/arrow-left-big-v2.svg'
import ArrowRightBig from 'assets/icons/arrow-right-big.svg'
import ArrowRightBigV2 from 'assets/icons/arrow-right-big-v2.svg'
import ArrowRightCompact from 'assets/icons/arrow-right-compact.svg'
import AttachmentSvg from 'assets/icons/attachment.svg'
import AutoTag from 'assets/icons/auto-tag.svg'
import BoxSvg from 'assets/icons/box.svg'
import BrowseSvg from 'assets/icons/browse.svg'
import BusinessCenterSvg from 'assets/icons/business-center.svg'
import CalendarSvg from 'assets/icons/calendar.svg'
import CancelSvg from 'assets/icons/cancel.svg'
import CheckSvg from 'assets/icons/check.svg'
import CheckCircleSvg from 'assets/icons/check-circle.svg'
import CheckOutlineSvg from 'assets/icons/check-outline.svg'
import CheckboxSvg from 'assets/icons/checkbox.svg'
import ChevronLeft from 'assets/icons/chevron-left.svg'
import ChevronRight from 'assets/icons/chevron-right.svg'
import ClearSvg from 'assets/icons/clear.svg'
import CloseSvg from 'assets/icons/close.svg'
import CommentSvg from 'assets/icons/comment.svg'
import ContactMailSvg from 'assets/icons/contact-mail.svg'
import CopySvg from 'assets/icons/copy.svg'
import CrisisAlertSvg from 'assets/icons/crisis-alert.svg'
import DeleteBucketSvg from 'assets/icons/delete-bucket.svg'
import DiscoLogoSquareSvg from 'assets/icons/disco-logo-square.svg'
import DownloadArrowSvg from 'assets/icons/download-arrow.svg'
import DownloadEmbedSvg from 'assets/icons/download-embed.svg'
import DropboxSvg from 'assets/icons/dropbox.svg'
import EditSvg from 'assets/icons/edit.svg'
import EditDocumentSvg from 'assets/icons/edit-document.svg'
import EditLargeSvg from 'assets/icons/edit-large.svg'
import EllipsisVerticalSvg from 'assets/icons/ellipsis-vertical.svg'
import EmailDraft from 'assets/icons/email-draft.svg'
import EmailScheduled from 'assets/icons/email-scheduled.svg'
import EmailSent from 'assets/icons/email-sent.svg'
import EmptyCalendarSvg from 'assets/icons/empty-calendar.svg'
import ErrorSvg from 'assets/icons/error.svg'
import FileDownloadSvg from 'assets/icons/file-download.svg'
import FilterSvg from 'assets/icons/filter.svg'
import FolderSvg from 'assets/icons/folder.svg'
import FolderOutlineSvg from 'assets/icons/folder-outline.svg'
import FormatCsvSvg from 'assets/icons/format-csv.svg'
import FormatListSvg from 'assets/icons/format-list.svg'
import FormatPdfSvg from 'assets/icons/format-pdf.svg'
import FormatSpreadsheetSvg from 'assets/icons/format-spreadsheet.svg'
import FormatUnknownSvg from 'assets/icons/format-unknown.svg'
import GoogleDriveSvg from 'assets/icons/google-drive.svg'
import HeartSvg from 'assets/icons/heart.svg'
import HelpSvg from 'assets/icons/help.svg'
import ImageAddSvg from 'assets/icons/image-add.svg'
import InboxSvg from 'assets/icons/inbox.svg'
import InfoSvg from 'assets/icons/info.svg'
import InfoOutlineSvg from 'assets/icons/info-outline.svg'
import InviteSvg from 'assets/icons/invite.svg'
import LibrariesSvg from 'assets/icons/libraries.svg'
import LibraryMusic from 'assets/icons/library-music.svg'
import LinkSvg from 'assets/icons/link.svg'
import LockSvg from 'assets/icons/lock.svg'
import LockOpenSvg from 'assets/icons/lock-open.svg'
import LyricsSvg from 'assets/icons/lyrics.svg'
import MailSendSvg from 'assets/icons/mail-send.svg'
import MergeSvg from 'assets/icons/merge.svg'
import MusicNoteSvg from 'assets/icons/music-note.svg'
import NavCloseSvg from 'assets/icons/nav-close.svg'
import NavOpenSvg from 'assets/icons/nav-open.svg'
import NotificationSvg from 'assets/icons/notification.svg'
import OneDriveSvg from 'assets/icons/one-drive.svg'
import OpenInNewTabSvg from 'assets/icons/open-in-new-tab.svg'
import OpenInNewTabCircleSvg from 'assets/icons/open-in-new-tab-circle.svg'
import PenSvg from 'assets/icons/pen.svg'
import PersonAddSvg from 'assets/icons/person-add.svg'
import PinCircleSvg from 'assets/icons/pin-circle.svg'
import PlayerNextSvg from 'assets/icons/player-next.svg'
import PauseIconSvg from 'assets/icons/player-pause.svg'
import PlayIconSvg from 'assets/icons/player-play.svg'
import PlayerPlaylistSvg from 'assets/icons/player-playlist.svg'
import PlayerPrevSvg from 'assets/icons/player-prev.svg'
import PlayerVolumeSvg from 'assets/icons/player-volume.svg'
import PlaylistAddSvg from 'assets/icons/playlist-add.svg'
import PlaylistV2Svg from 'assets/icons/playlist-v2.svg'
import PreReleaseSvg from 'assets/icons/pre-release.svg'
import ProfileSvg from 'assets/icons/profile.svg'
import ProfilesSvg from 'assets/icons/profiles.svg'
import QrCodeSvg from 'assets/icons/qr.svg'
import ReloadSvg from 'assets/icons/reload.svg'
import SearchV2Svg from 'assets/icons/search-v2.svg'
import SendSvg from 'assets/icons/send.svg'
import ShareSvg from 'assets/icons/share.svg'
import SoundwaveSvg from 'assets/icons/soundwave.svg'
import StarInBoxSvg from 'assets/icons/star-in-box.svg'
import StarV2Svg from 'assets/icons/star-v2.svg'
import StarredSvg from 'assets/icons/starred.svg'
import StatsSvg from 'assets/icons/stats.svg'
import StatsLiteSvg from 'assets/icons/stats-lite.svg'
import ThumbsUpSvg from 'assets/icons/thumbs-up.svg'
import TrendingUpSvg from 'assets/icons/trending-up.svg'
import UploadSvg from 'assets/icons/upload.svg'
import UploadFileSvg from 'assets/icons/upload-file.svg'
import UserSvg from 'assets/icons/user.svg'
import UserCircleSvg from 'assets/icons/user-circle.svg'
import WarningSvg from 'assets/icons/warning.svg'
import WatchSvg from 'assets/icons/watch.svg'
import WatermarkingSvg from 'assets/icons/watermarking.svg'
import WatermarkingLogoSvg from 'assets/icons/watermarking-logo.svg'
import WorldSvg from 'assets/icons/world.svg'
import ZoomInSvg from 'assets/icons/zoom-in.svg'
import ZoomOutSvg from 'assets/icons/zoom-out.svg'
import SavedToDiscoSvg from 'assets/icons/saved-to-disco.svg'
import DiscoBtnIcon from './disco-btn-icon'
import ShareArrowIcon from './share-arrow-icon'
export { FaArrowUp as ArrowUpThick } from '@react-icons/all-files/fa/FaArrowUp'
export { FaCheck as SuccessCheck } from '@react-icons/all-files/fa/FaCheck'
export { MdArrowUpward as ArrowUp } from '@react-icons/all-files/md/MdArrowUpward'
// TODO: deprecate in favour of svg-icons(export icon directly instead so code-splitting would work)
export const svgComponentMapping = {
  'add-circle': (<AddCircleSvg width="24" height="24" />) as React.ReactNode,
  'add-tag': (<AddTag />) as React.ReactNode,
  'time-clock': (<ClockSvg width="24" height="24" />) as React.ReactNode,
  album: (<AlbumSvg width="24" height="24" />) as React.ReactNode,
  'auto-tag': (<AutoTag />) as React.ReactNode,
  'arrow-down': (<ArrowDownSvg width="24" height="24" />) as React.ReactNode,
  'arrow-left': (<ChevronLeft width="24" height="24" />) as React.ReactNode,
  'arrow-right': (<ChevronRight width="24" height="24" />) as React.ReactNode,
  'arrow-right-big': (<ArrowRightBig />) as React.ReactNode,
  'arrow-right-big-v2': (
    <ArrowRightBigV2 width="24" height="24" />
  ) as React.ReactNode,
  'arrow-right-compact': (
    <ArrowRightCompact width="24" height="24" />
  ) as React.ReactNode,
  'arrow-left-big-v2': (
    <ArrowLeftBigV2 width="24" height="24" />
  ) as React.ReactNode,
  attachment: (<AttachmentSvg width="24" height="24" />) as React.ReactNode,
  box: (<BoxSvg width="24" height="24" />) as React.ReactNode,
  browse: (<BrowseSvg width="24" height="24" />) as React.ReactNode,
  'business-center': (
    <BusinessCenterSvg width="24" height="24" />
  ) as React.ReactNode,
  calendar: (<CalendarSvg width="24" height="24" />) as React.ReactNode,
  cancel: (<CancelSvg width="24" height="24" />) as React.ReactNode,
  check: (<CheckSvg width="24" height="24" />) as React.ReactNode,
  'check-circle': (
    <CheckCircleSvg width="24" height="24" />
  ) as React.ReactNode,
  'check-outline': (
    <CheckOutlineSvg width="24" height="24" />
  ) as React.ReactNode,
  clear: (<ClearSvg width="24" height="24" />) as React.ReactNode,
  close: (<CloseSvg width="24" height="24" />) as React.ReactNode,
  copy: (<CopySvg width="24" height="24" />) as React.ReactNode,
  comment: (<CommentSvg width="24" height="24" />) as React.ReactNode,
  'contact-mail': (
    <ContactMailSvg width="24" height="24" />
  ) as React.ReactNode,
  csv: (<FormatCsvSvg width="24" height="24" />) as React.ReactNode,
  checkbox: (<CheckboxSvg width="24" height="24" />) as React.ReactNode,
  'crisis-alert': (
    <CrisisAlertSvg width="24" height="24" />
  ) as React.ReactNode,
  'disco-logo-square': (
    <DiscoLogoSquareSvg width="24" height="24" />
  ) as React.ReactNode,
  dropbox: (<DropboxSvg width="24" height="24" />) as React.ReactNode,
  'download-embed': (<DownloadEmbedSvg />) as React.ReactNode,
  'download-arrow': (<DownloadArrowSvg />) as React.ReactNode,
  'delete-bucket': (
    <DeleteBucketSvg width="24" height="24" />
  ) as React.ReactNode,
  edit: (<EditSvg width="24" height="24" />) as React.ReactNode,
  'edit-document': (
    <EditDocumentSvg width="24" height="24" />
  ) as React.ReactNode,
  'edit-large': (<EditLargeSvg width="24" height="24" />) as React.ReactNode,
  'ellipsis-vertical': (
    <EllipsisVerticalSvg width="24" height="24" />
  ) as React.ReactNode,
  error: (<ErrorSvg width="24" height="24" />) as React.ReactNode,
  'email-draft': (<EmailDraft width="24" height="24" />) as React.ReactNode,
  'email-scheduled': (
    <EmailScheduled width="24" height="24" />
  ) as React.ReactNode,
  'email-sent': (<EmailSent width="24" height="24" />) as React.ReactNode,
  'file-download': (
    <FileDownloadSvg width="24" height="24" />
  ) as React.ReactNode,
  filter: (<FilterSvg width="24" height="24" />) as React.ReactNode,
  folder: (<FolderSvg width="24" height="24" />) as React.ReactNode,
  'folder-outline': (
    <FolderOutlineSvg width="24" height="24" />
  ) as React.ReactNode,
  'format-list': (<FormatListSvg width="24" height="24" />) as React.ReactNode,
  'google-drive': (
    <GoogleDriveSvg width="24" height="24" />
  ) as React.ReactNode,
  heart: (<HeartSvg width="24" height="24" />) as React.ReactNode,
  help: (<HelpSvg width="24" height="24" />) as React.ReactNode,
  'image-add': (<ImageAddSvg width="24" height="24" />) as React.ReactNode,
  inbox: (<InboxSvg width="24" height="24" />) as React.ReactNode,
  info: (<InfoSvg width="24" height="24" />) as React.ReactNode,
  'info-outline': (
    <InfoOutlineSvg width="24" height="24" />
  ) as React.ReactNode,
  invite: (<InviteSvg width="24" height="24" />) as React.ReactNode,
  libraries: (<LibrariesSvg width="24" height="24" />) as React.ReactNode,
  link: (<LinkSvg width="24" height="24" />) as React.ReactNode,
  lock: (<LockSvg width="24" height="24" />) as React.ReactNode,
  'lock-open': (<LockOpenSvg width="24" height="24" />) as React.ReactNode,
  lyrics: (<LyricsSvg width="24" height="24" />) as React.ReactNode,
  'mail-send': (<MailSendSvg width="24" height="24" />) as React.ReactNode,
  'music-note': (<MusicNoteSvg width="24" height="24" />) as React.ReactNode,
  merge: (<MergeSvg width="24" height="24" />) as React.ReactNode,
  'nav-close': (<NavCloseSvg width="24" height="24" />) as React.ReactNode,
  'nav-open': (<NavOpenSvg width="24" height="24" />) as React.ReactNode,
  notification: (<NotificationSvg width="24" height="24" />) as React.ReactNode,
  'one-drive': (<OneDriveSvg width="24" height="24" />) as React.ReactNode,
  'open-in-new-tab': (
    <OpenInNewTabSvg width="24" height="24" />
  ) as React.ReactNode,
  'open-in-new-tab-circle': (
    <OpenInNewTabCircleSvg width="24" height="24" />
  ) as React.ReactNode,
  pdf: (<FormatPdfSvg width="24" height="24" />) as React.ReactNode,
  pen: (<PenSvg width="24" height="24" />) as React.ReactNode,
  'person-add': (<PersonAddSvg width="24" height="24" />) as React.ReactNode,
  'pin-circle': (<PinCircleSvg width="24" height="24" />) as React.ReactNode,
  'player-next': (<PlayerNextSvg width="24" height="24" />) as React.ReactNode,
  'player-playlist': (
    <PlayerPlaylistSvg width="24" height="24" />
  ) as React.ReactNode,
  'player-prev': (<PlayerPrevSvg width="24" height="24" />) as React.ReactNode,
  'player-volume': (
    <PlayerVolumeSvg width="24" height="24" />
  ) as React.ReactNode,
  'playlist-add': (
    <PlaylistAddSvg width="24" height="24" />
  ) as React.ReactNode,
  playlist: (<PlaylistV2Svg width="24" height="24" />) as React.ReactNode,
  profile: (<ProfileSvg width="24" height="24" />) as React.ReactNode,
  profiles: (<ProfilesSvg width="24" height="24" />) as React.ReactNode,
  'pre-release': (<PreReleaseSvg width="24" height="24" />) as React.ReactNode,
  play: (<PlayIconSvg width="24" height="24" />) as React.ReactNode,
  pause: (<PauseIconSvg width="24" height="24" />) as React.ReactNode,
  qr: (<QrCodeSvg width="24" height="24" />) as React.ReactNode,
  reload: (<ReloadSvg width="24" height="24" />) as React.ReactNode,
  search: (<SearchV2Svg width="24" height="24" />) as React.ReactNode,
  send: (<SendSvg width="24" height="24" />) as React.ReactNode,
  share: (<ShareSvg width="24" height="24" />) as React.ReactNode,
  soundwave: (<SoundwaveSvg width="24" height="24" />) as React.ReactNode,
  spreadsheet: (
    <FormatSpreadsheetSvg width="24" height="24" />
  ) as React.ReactNode,
  star: (<StarV2Svg width="24" height="24" />) as React.ReactNode,
  starred: (<StarredSvg width="24" height="24" />) as React.ReactNode,
  'star-in-box': (<StarInBoxSvg width="24" height="24" />) as React.ReactNode,
  stats: (<StatsSvg width="24" height="24" />) as React.ReactNode,
  'stats-lite': (<StatsLiteSvg width="24" height="24" />) as React.ReactNode,
  'thumbs-up': (<ThumbsUpSvg width="24" height="24" />) as React.ReactNode,
  track: (<LibraryMusic width="24" height="24" />) as React.ReactNode,
  'trending-up': (<TrendingUpSvg width="24" height="24" />) as React.ReactNode,
  unknown: (<FormatUnknownSvg width="24" height="24" />) as React.ReactNode,
  upload: (<UploadSvg width="24" height="24" />) as React.ReactNode,
  'upload-file': (<UploadFileSvg width="24" height="24" />) as React.ReactNode,
  'user-circle': (<UserCircleSvg width="24" height="24" />) as React.ReactNode,
  user: (<UserSvg width="24" height="24" />) as React.ReactNode,
  watch: (<WatchSvg width="24" height="24" />) as React.ReactNode,
  warning: (<WarningSvg width="24" height="24" />) as React.ReactNode,
  'empty-calendar': (
    <EmptyCalendarSvg width="24" height="24" />
  ) as React.ReactNode,
  'watermarking-logo': (
    <WatermarkingLogoSvg width="24" height="24" />
  ) as React.ReactNode,
  watermarking: (<WatermarkingSvg width="24" height="24" />) as React.ReactNode,
  world: (<WorldSvg width="24" height="24" />) as React.ReactNode,
  'zoom-in': (<ZoomInSvg width="24" height="24" />) as React.ReactNode,
  'zoom-out': (<ZoomOutSvg width="24" height="24" />) as React.ReactNode,
  'saved-to-disco': (
    <SavedToDiscoSvg width="24" height="24" />
  ) as React.ReactNode,
  ' ': (<svg />) as React.ReactElement<'svg'>,
}

export type IconKey =
  | keyof typeof svgComponentMapping
  | keyof typeof textComponentMapping

export const textComponentMapping = {
  people: PeopleIcon,
  'check-circle': CheckCircle,
  trash: TrashIcon,
  envelope: EnvelopeIcon,
  'keyboard-arrow-left': ChevronLeft,
  'download-arrow': DropDownArrow,
  'arrow-drop-down': ArrowDropDown,
  spinner: SpinnerIcon,
  remove: RemoveIcon,
  'credit-card': CreditCard,
  // text editor icons
  bold: FormatBold,
  italic: FormatItalic,
  underline: FormatUnderlined,
  'numbered-list': FormatListNumbered,
  'bulleted-list': FormatListBulleted,
  'align-left': FormatAlignLeft,
  'align-center': FormatAlignCenter,
  'align-right': FormatAlignRight,
  'align-justify': FormatAlignJustify,
  'disco-btn': DiscoBtnIcon,
  ellipsis: EllipsisIcon,
  image: ImageIcon,
  'remove-link': BrokenLinkIcon,
  drag: DragIcon,
  cancel: CancelIcon,
  'color-text': MdFormatColorText,
  'color-fill': MdFormatColorFill,
  'format-clear': MdFormatClear, // -----------------
  'share-arrow': ShareArrowIcon,
}

/**
 * @deprecated The component should not be used as it prevents tree-shaking, use icon directly instead
 * @see svg-icons.tsx for example
 *
 * A legacy icon component that dynamically renders SVG or text icons based on the type prop.
 * This component is deprecated in favor of importing icons directly for better tree-shaking.
 *
 * @param type - The icon type/key to render from the available icon mappings
 * @param width - Optional width for the icon
 * @param height - Optional height for the icon
 * @param color - Optional color for the icon
 * @param className - Optional CSS class name
 * @param id - Optional DOM ID
 * @param style - Optional inline styles
 * @param onClick - Optional click handler
 * @returns The rendered icon component
 */
class Icon extends React.PureComponent<{
  type: IconKey
  width?: number | string
  height?: number | string
  color?: string
  className?: string
  id?: string
  style?: React.CSSProperties
  onClick?: () => void
}> {
  render(): React.ReactNode | React.ReactNode {
    const { type, ...rest } = this.props
    const component = svgComponentMapping[type] || textComponentMapping[type]
    if (!component) throw new Error('Unknown icon type: ' + type)
    const { width, height, ...iconProps } = rest
    const size = width || height || 24
    return svgComponentMapping[type]
      ? React.cloneElement(component, rest)
      : React.createElement(component, { ...iconProps, size })
  }
}

export default Icon
